import React, { useState } from "react";
import { Col, Carousel } from 'react-bootstrap';
import BannerCard from "./bannercard";
import { useEffect } from "react";

const BannerCarousel = ({ images, handleBtn }) => {
    const [viewCarousel, setViewCarousel] = useState(false);

    useEffect(() => {
        (images.length > 0) ?
            setViewCarousel(true)
            : setViewCarousel(false)
    }, [images]);

    return (
        <>
            {(viewCarousel) ?
                <Carousel slide={false}>
                    {images.map((value) => (
                        <Carousel.Item>
                            <img
                                className='d-block w-100'
                                src={value}
                                alt="First slide"
                            />
                            <Carousel.Caption>
                                <Col md={{ span: 7, offset: 2 }} className='my-3'>
                                    <BannerCard handleBtn={handleBtn} />
                                </Col>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
                :
                <>
                    <Col md={{ span: 5, offset: 6 }} className='my-3'>
                        <BannerCard handleBtn={handleBtn} />
                    </Col>
                </>
            }
        </>
    );
}

export default BannerCarousel;
